import { render, staticRenderFns } from "./UsersAddUpdScreen.vue?vue&type=template&id=2985b6d1&scoped=true&"
import script from "./UsersAddUpdScreen.vue?vue&type=script&lang=js&"
export * from "./UsersAddUpdScreen.vue?vue&type=script&lang=js&"
import style0 from "./UsersAddUpdScreen.vue?vue&type=style&index=0&id=2985b6d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2985b6d1",
  null
  
)

export default component.exports